const PATRON_ID = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([\w-]{11})(?![\w-])/;

// Acepta "90", "90s" o "1h2m30s"
const segundos = valor => {
    if (!valor) return 0;
    if (/^\d+s?$/.test(valor)) return parseInt(valor, 10);
    const partes = valor.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
    if (!partes) return 0;
    const [, h = 0, m = 0, s = 0] = partes;
    return Number(h) * 3600 + Number(m) * 60 + Number(s);
};

export const obtenerEmbedYoutube = url => {
    const texto = (url ?? '').trim();
    const id = texto.match(PATRON_ID)?.[1];
    if (!id) return null;

    const inicio = segundos(texto.match(/[?&#](?:t|start)=([\dhms]+)/)?.[1]);
    return `https://www.youtube.com/embed/${id}` + (inicio ? `?start=${inicio}` : '');
};
